<template>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <ul>
            <li><router-link to="/contact">Contact</router-link></li>
            <li><router-link to="/privacy">Privacy Policy</router-link></li>
            <li><router-link to="/terms">Terms of Use</router-link></li>
            <li><router-link to="/sitemap">Sitemap</router-link></li>
          </ul>
        </div>
        <div class="footer-info">
          <p>&copy; 2025 RANDOMCRITD</p>
        </div>
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent',
  };
  </script>
  
  <style scoped>
 .footer {
  color: #FF9442;
  padding: 10px 0;
  text-align: center;
  font-size: 0.9rem;
  width: 100%;
  position: relative; /* no fixed positioning */
}
  
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
  }
  
  .footer-links ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
  }
  
  .footer-links li {
    margin-right: 15px;
  }
  
  .footer-links a {
    color: white;
    text-decoration: none;
  }
  
  .footer-links a:hover {
    text-decoration: underline;
  }
  
  .footer-info {
    font-size: 0.8rem;
  }
  </style>
  